import React from "react";

import { getData } from "../../utils/helpers";
import { BarChart, LineChart, DoughnutChart } from "../Chart";

import logo from "../../assets/images/logo.jpg";

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: getData()
    };
  }

  componentDidMount() {
    window.setInterval(() => {
      this.setState({
        data: getData()
      });
    }, 5000);
  }

  render() {
    return (
      <div className="App">
        <div className="main chart-wrapper">
          <div className="mb-8">
            <img src={logo} alt="Envases logo" />
          </div>
          <div className="flex justify-between h-full">
            <div className="w-1/2">
              <BarChart
                data={this.state.data[1].data}
                title={this.state.data[1].title}
                color="#920f05"
              />
            </div>
            <div className="w-1/2">
              <BarChart
                type="horizontalBar"
                data={this.state.data[1].data}
                title={this.state.data[1].title}
                color="#920f05"
              />
            </div>
          </div>

          {/* <LineChart
            data={this.state.data[0].data}
            title={this.state.data[0].title}
            color="#3E517A"
          /> */}
        </div>
        {/* <div className="sub chart-wrapper">
          <BarChart
            data={this.state.data[1].data}
            title={this.state.data[1].title}
            color="#70CAD1"
          />
        </div> */}
        {/* <div className="sub chart-wrapper">
          <BarChart
            data={this.state.data[2].data}
            title={this.state.data[2].title}
            color="#B08EA2"
          />
        </div> */}
        {/* <div className="sub chart-wrapper">
          <DoughnutChart
            data={this.state.data[3].data}
            title={this.state.data[3].title}
            colors={[
              "#a8e0ff",
              "#8ee3f5",
              "#70cad1",
              "#3e517a",
              "#b08ea2",
              "#BBB6DF"
            ]}
          />
        </div> */}
      </div>
    );
  }
}

export default App;
